import React, { useEffect, useState } from 'react';

import { Row, Col, Card, CardBody } from "reactstrap";
import { Link } from "react-router-dom";

import avatar1 from "../../assets/images/users/avatar-1.jpg";
import profileImg from "../../assets/images/profile-img.png";

const WelcomeComp = (props) => {

    const [username, setusername] = useState('');

    useEffect(() => {
           if(localStorage.getItem("user"))
           {
                const obj = JSON.parse(localStorage.getItem("user"));
                setusername(obj.name);
          }
      },[]);

          return (
           <React.Fragment>
                <Card className="overflow-hidden">
                    <div className="bg-soft-primary">
                        <Row>
                            <Col xs="7">
                                <div className="text-primary p-3">
                                    <h5 className="text-primary">Bienvenido !</h5>
                                </div>
                            </Col>
                            <Col xs="5" className="align-self-end">
                                <img src={profileImg} alt="" className="img-fluid" />
                            </Col>
                        </Row>
                    </div>
                    <CardBody className="pt-0">
                        <Row>
                            <Col sm="4">
                                <div className="avatar-md profile-user-wid mb-4">
                                    <img src={avatar1} alt="" className="img-thumbnail rounded-circle" />
                                </div>
                                <h5 className="font-size-15 text-truncate">{username}</h5>
                                <p className="text-muted mb-0 text-truncate">Administrador</p>
                            </Col>

                            <Col sm="8">
                                <div className="pt-4">
                                    <Row>
                                        <Col xs="6">
                                            <h5 className="font-size-15">125</h5>
                                            <p className="text-muted mb-0">Projects</p>
                                        </Col>
                                        <Col xs="6">
                                            <h5 className="font-size-15">$1245</h5>
                                            <p className="text-muted mb-0">Revenue</p>
                                        </Col>
                                    </Row>
                                    <div className="mt-4">
                                        <Link to="" className="btn btn-primary waves-effect waves-light btn-sm">Ver perfil <i className="mdi mdi-arrow-right ml-1"></i></Link>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </React.Fragment>
          );
        }
export default WelcomeComp;
 